import {Box, Container as BaseContainer, ContainerProps as BaseContainerProps} from '@panda/jsx';

interface ContainerProps extends BaseContainerProps {
	bg?: 'default' | 'hero' | (string & {});
	boxClassName?: string;
}

export const Container = ({
	children,
	className,
	boxClassName = '',
	bg = 'default',
	...rest
}: ContainerProps) => {
	const defaultBgColor =
		'linear-gradient(var(--color-background-elevated-low-default), rgba(255, 255, 255, 0) 50em)';

	const background = (() => {
		switch (bg) {
			case 'hero': {
				return `linear-gradient(200deg, rgba(135, 24, 157, 0.5) -12.2%, rgba(172, 79, 198, 0) 59.52%), ${defaultBgColor}`;
			}
			case 'default': {
				return defaultBgColor;
			}
			default: {
				return bg;
			}
		}
	})();

	return (
		<Box style={{background}} className={boxClassName}>
			<BaseContainer
				className={`responsive-container ${className}`}
				position="relative"
				margin="auto"
				width={{base: 'calc(100% - 48px)', lg: '60%'}}
				pb="40px"
				maxW={1600}
				{...rest}>
				{children}
			</BaseContainer>
		</Box>
	);
};
